import { createContext } from 'react';

const FriendContext = createContext();

export default FriendContext;